module.exports = __webpack_public_path__ + "img/advanced.32ee0ecf.png";